import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo FileUpload - 刪除已上傳的檔案
 */
const DeleteUploadedFile = [
    'POST',
    RouteUrlList.API_DeleteUploadedFile.path,
    {
        itemID: 101
    },
    200,
    {
        status: true,
        code: 0,
        exception: null,
        message: '已成功刪除上傳項目的檔案',
        result: [
            'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
            'b2c3d4e5-f6a7-8901-bcde-f12345678901'
        ]
    }
];

export default DeleteUploadedFile;
